export const Columns = {
    SOLD_DATE: 'SOLD_DATE',
    ATTENDEE: 'ATTENDEE',
    ATTENDEE_ID: 'ATTENDEE_ID',
    MEMBERSHIP_CODE: 'MEMBERSHIP_CODE',
    COMPANY: 'COMPANY',
    BARCODE: 'BARCODE',
    RATE: 'RATE',
    PAID_PRICE: 'PAID_PRICE',
    SEAT: 'SEAT',
    SESSION: 'SESSION',
    SCANNED: 'SCANNED',
    STATUS: 'STATUS',
    MODERATION_STATUS: 'MODERATION_STATUS',
    MAILS: 'MAILS',
    PARTNER: 'PARTNER',
    ACTIONS: 'ACTIONS'
};
